@if (config()?.showDetails) {
    <product-view-details
        class="card9"
        [product]="product()"
        [categoryConfig]="categoryConfig()"
        [priceInfo]="prices()"
        [templateConfiguration]="config()"
        [gridType]="gridType()"
        [colorStyle]="productStyle()?.tintColor"
        (onClick)="navigateToProduct($event)"
    ></product-view-details>
}
@if (config()?.showLongDescription) {
    <span class="title-s ttu limited-after-card9">{{ product()?.longDescription }}</span>
}
